const urls = {
    //API_URL: 'http://localhost:58039/v1.0' //'https://gamifieddashboardsapi.azurewebsites.net/v1.0'
    API_URL: process.env.REACT_APP_API_ENV === 'PRODUCTION' ? 'https://api.aheadofthegame.uk.com/v1.0' : 'https://gamifieddashboardsapi.azurewebsites.net/v1.0'
};

export default urls;